module.exports = __webpack_public_path__ + "nc_static/media/line-chart.svg.93687f94.icon";